export default __webpack_public_path__ + "static/media/006-mushroom.21576f92.svg";